/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/pointsMall',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '积分商城',
      icon: 'component',
    },
    children: [
      {
        path: '/pointsMall/columnList',
        component: () => import('@/myviews/EB_pointsMall/columnList.vue'),
        alwaysShow: false,
        name: 'Column',
        meta: {
          title: '栏目配置',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/pointsMall/bannerConfig',
        component: () => import('@/myviews/EB_pointsMall/bannerConfig/bannerConfig.vue'),
        alwaysShow: false,
        name: 'BannerConfig',
        meta: {
          title: 'banner配置',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/pointsMall/exchangeGood',
        component: () => import('@/myviews/EB_pointsMall/exchangeGood/exchangeGood.vue'),
        alwaysShow: false,
        name: 'ExchangeGood',
        meta: {
          title: '兑换商品',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/pointsMall/integralMallSort',
        component: () => import('@/myviews/EB_pointsMall/integralMallSort.vue'),
        alwaysShow: false,
        name: 'IntegralMallSort',
        meta: {
          title: '积分商品分类',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      },
       ]
  }
]




// WEBPACK FOOTER //
// ./src/router/pointsManage/AB_pointsMall.js